import React from 'react'
import cx from 'classnames'

import { EditorialCard } from 'src/components/editorial/editorialCard'

export interface FurtherReadingProps {
  data: {
    backgroundColor?: string
    spacing?: string
    title?: string
    articles: any[]
  }
}

export const FurtherReading = ({ data }: FurtherReadingProps) => {
  const { title, backgroundColor, articles, spacing } = data

  return (
    <div
      className={cx('rel further__reading', backgroundColor, spacing, {
        cw: backgroundColor === 'bcb',
        pym: spacing === undefined,
        'cw bcb': backgroundColor === undefined,
      })}
    >
      <div className="container--l outer mxa py2 p1 al x rel z2">
        {title && <h5 className="caps mono">{title}</h5>}
        <div className="f jcb aist further__reading-articles fw">
          {articles?.map(article => (
            <EditorialCard
              key={article._id}
              className="col-m-32 x"
              {...article.content.main}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default FurtherReading
